/* eslint-disable */
/**
 * Import from node_modules
 */
/**
 * Import site scripts
 */
import PredictiveSearch from './site/predictive-search';
import SplideExample from './site/_splide-example';
import Mix from './site/mix';
import Sliders from './site/sliders';
import EqualHeights from './site/equalHeights';
import ProductGrid from './site/product-grid';
import Collection from './site/collection';
import Header from './site/header';
import ProductReviews from './site/product-reviews';
//import RechargeCustomSubscription from './site/recharge-custom-subscription';
import AnimationOnScroll from './site/animation-on-scroll'
import Login from './site/login';
import Account from './site/account';
import Buybox from './site/buybox';
import ProductGallery from './site/product-gallery';
import Article from './site/article';
import KlaviyoNewsletter from './site/klaviyo-newsletter';
import AddToCart from './site/addToCart';
import Contact from './site/contact';
 
/**
 * Init site scripts 
 */
document.addEventListener('DOMContentLoaded', function() {
	PredictiveSearch.init();
	SplideExample.init();
	Mix.init();
	Sliders.init();
	EqualHeights.init();
	ProductGrid.init();
	Collection.init();
	Header.init();
	ProductReviews.init();
	//RechargeCustomSubscription.init();
	AnimationOnScroll.init();
	Login.init();
	Account.init();
	Buybox.init();
	Article.init();
	ProductGallery.init();
	KlaviyoNewsletter.init();
	AddToCart.init();
	Contact.init();
});
